import Layout from "../components/Layout";
import { HistorialCobranza } from "../components/historialCobranza";

const HistorialCobr = () => {
	return (
		<>      
		<Layout/>
		<HistorialCobranza/>
		</>
	);
}

export default HistorialCobr; 